import React, { useLayoutEffect, useState } from "react";

import type { SkillDocumentJson } from "../utils/skill-markdown-convert";

import { MarkdownEditor } from "./MarkdownEditor";

import LoadingSpinner from "@/components/LoadingSpinner";

interface RichMarkdownEditorPaneProps {
  editedContent: string | undefined;
  isDraftFile: boolean;
  dataContent: string | undefined;
  documentJson: SkillDocumentJson | undefined;
  fallbackMarkdown: string;
  hasImportedContent?: boolean;
  onClearImportFlag?: () => void;
  onInitialLoad: (content: string) => void;
  onDocumentJsonChange: (doc: SkillDocumentJson) => void;
  onEditorReady?: (doc: SkillDocumentJson) => void;
}

export const RichMarkdownEditorPane = ({
  editedContent,
  isDraftFile,
  dataContent,
  documentJson,
  fallbackMarkdown,
  hasImportedContent,
  onClearImportFlag,
  onInitialLoad,
  onDocumentJsonChange,
  onEditorReady,
}: RichMarkdownEditorPaneProps) => {
  const shouldDeferMount = !isDraftFile && editedContent === undefined;
  const [hydrated, setHydrated] = useState(!shouldDeferMount);

  useLayoutEffect(() => {
    if (isDraftFile || editedContent !== undefined) {
      setHydrated(true);
      return;
    }

    if (dataContent !== undefined) {
      onInitialLoad(dataContent);
      setHydrated(true);
    } else {
      setHydrated(false);
    }
  }, [dataContent, editedContent, isDraftFile, onInitialLoad]);

  if (shouldDeferMount && !hydrated) {
    return (
      <div className="flex h-full min-h-0 flex-1 items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <MarkdownEditor
      documentJson={documentJson}
      fallbackMarkdown={fallbackMarkdown}
      hasImportedContent={hasImportedContent}
      onClearImportFlag={onClearImportFlag}
      onDocumentChange={onDocumentJsonChange}
      onEditorReady={onEditorReady}
    />
  );
};
